<template>
	<div class="pdd-goods-page">
		<template v-if="pageView === 'list'">
		<section class="filter-card">
			<el-form :model="formfilter" inline size="small" class="filter-form" label-width="0">
				<div class="filter-row">
					<el-form-item>
						<el-select
							v-model="formfilter.retail_shop_id"
							placeholder="全部"
							filterable
							:loading="shopLoading"
							class="filter-control"
							@change="onShopChange"
						>
							<el-option label="全部" value="" />
							<el-option
								v-for="item in shopList"
								:key="item.id"
								:label="item.mall_name || item.shop_name"
								:value="String(item.id)"
							/>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="formfilter.goods_status" placeholder="商品状态" class="filter-control">
							<el-option
								v-for="item in goodsStatusOptions"
								:key="String(item.value)"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="formfilter.stock_sync" placeholder="同步库存" class="filter-control">
							<el-option label="同步库存-全部" value="" />
							<el-option label="同步库存-同步" :value="1" />
							<el-option label="同步库存-不同步" :value="0" />
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="formfilter.sync_rule" placeholder="同步规则" class="filter-control">
							<el-option label="同步规则-全部" value="" />
							<el-option v-for="item in syncRuleOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="formfilter.auto_order" placeholder="自动下单" class="filter-control">
							<el-option label="自动下单-全部" value="" />
							<el-option label="自动下单-是" :value="1" />
							<el-option label="自动下单-否" :value="0" />
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="formfilter.is_deleted" placeholder="删除状态" class="filter-control">
							<el-option label="删除状态-全部" value="" />
							<el-option label="删除状态-未删除" :value="0" />
							<el-option label="删除状态-已删除" :value="1" />
						</el-select>
					</el-form-item>
				</div>
				<div class="filter-row filter-row--second">
					<el-form-item class="keyword-item">
						<span class="keyword-label">关键字</span>
						<el-input
							v-model="formfilter.keyword"
							placeholder="编号、名称、Code多个用逗号分割"
							clearable
							class="keyword-input"
						/>
					</el-form-item>
					<el-form-item class="keyword-item">
						<span class="keyword-label">当前页面</span>
						<el-select v-model="formfilter.tag" placeholder="全部" class="labeled-select">
							<el-option
								v-for="item in tagOptions"
								:key="String(item.value)"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
					</el-form-item>
					<el-form-item class="keyword-item">
						<span class="keyword-label">库存同步状态</span>
						<el-select v-model="formfilter.stock_sync_status" placeholder="全部" class="labeled-select">
							<el-option
								v-for="item in stockSyncStatusOptions"
								:key="String(item.value)"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
					</el-form-item>
					<el-form-item class="keyword-item">
						<span class="keyword-label">价格同步状态</span>
						<el-select v-model="formfilter.price_sync_status" placeholder="全部" class="labeled-select">
							<el-option
								v-for="item in priceSyncStatusOptions"
								:key="String(item.value)"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
					</el-form-item>
					<div class="filter-actions">
						<el-button type="primary" class="btn-search" @click="onfilter">搜索</el-button>
						<el-button class="btn-ghost" @click="onreset">重置</el-button>
					</div>
				</div>
			</el-form>
		</section>

		<section class="toolbar-card">
			<div class="toolbar-group">
				<div class="toolbar-btns">
					<button
						v-for="item in bulkPrimary"
						:key="item.key"
						type="button"
						class="tool-btn tool-btn--brand"
						@click="onBulkAction(item)"
					>{{ item.label }}</button>
				</div>
			</div>
			<div v-if="selectedRows.length" class="selection-tip">
				已选 <strong>{{ selectedRows.length }}</strong> 条
			</div>
		</section>

		<section class="table-card" ref="tableCard">
			<el-table
				v-loading="loading"
				:data="list"
				:height="tableHeight"
				border
				size="small"
				class="goods-table"
				@selection-change="handleSelectionChange"
			>
				<el-table-column type="selection" width="42" align="center" fixed="left" />
				<el-table-column type="index" label="序号" width="56" align="center" :index="indexMethod" />
				<el-table-column label="图片" width="76" align="center">
					<template slot-scope="scope">
						<div class="thumb">
							<img v-if="scope.row.image_url" :src="scope.row.image_url" alt="">
							<i v-else class="el-icon-picture-outline"></i>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="mall_name" label="店铺名称" min-width="120" align="center" class-name="cell-wrap-column">
					<template slot-scope="scope">
						<div class="cell-wrap-full">{{ scope.row.mall_name || '-' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="商品编号/款号" min-width="140" align="center">
					<template slot-scope="scope">
						<div class="cell-main">{{ displayCell(scope.row.goods_id) }}</div>
						<el-tooltip
							v-if="scope.row.sku_code"
							:content="scope.row.sku_code"
							placement="top"
							:open-delay="300"
							effect="light"
						>
							<div class="cell-sub cell-sub-ellipsis">{{ scope.row.sku_code }}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="商品状态" width="76" align="center">
					<template slot-scope="scope">
						<span class="status-tag" :class="goodsStatusClass(scope.row)">{{ formatGoodsStatus(scope.row) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="同步规则" min-width="168" align="center">
					<template slot-scope="scope">
						<el-select v-model="scope.row.sync_rule" size="small" placeholder="请选择" class="rule-select" @change="onSyncRuleChange(scope.row)">
							<el-option v-for="item in syncRuleTableOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<button v-if="showRuleConfigBtn(scope.row)" type="button" class="link-btn" @click="onRuleConfig(scope.row)">参数配置</button>
					</template>
				</el-table-column>
				<el-table-column label="自动下单" width="88" align="center">
					<template slot-scope="scope">{{ formatAutoOrderRow(scope.row) }}</template>
				</el-table-column>
				<el-table-column label="同步库存" width="128" align="center">
					<template slot-scope="scope">
						<div class="status-cell" :class="Number(scope.row.stock_sync) === 1 ? 'is-on' : 'is-off'">
							<el-switch
								:value="getStockSyncValue(scope.row)"
								:active-value="1"
								:inactive-value="0"
								active-color="#ff4714"
								inactive-color="#dcdfe6"
								@change="onStockSyncChange(scope.row, $event)"
							/>
							<span class="status-label">{{ formatStockSyncText(scope.row) }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="库存同步时间" min-width="138" align="center" class-name="sync-status-column">
					<template slot-scope="scope">
						<div class="sync-status-cell">
							<span
								v-if="formatSyncStatus(scope.row.stock_sync_status) !== '-'"
								class="sync-status-tag"
								:class="'sync-status-tag--' + syncStatusTagType(scope.row.stock_sync_status)"
							>{{ formatSyncStatus(scope.row.stock_sync_status) }}</span>
							<span v-else class="sync-status-empty">-</span>
						</div>
						<div class="cell-time">{{ formatTime(scope.row.stock_sync_time) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="价格同步时间" min-width="138" align="center" class-name="sync-status-column">
					<template slot-scope="scope">
						<div class="sync-status-cell">
							<span
								v-if="formatSyncStatus(scope.row.price_sync_status) !== '-'"
								class="sync-status-tag"
								:class="'sync-status-tag--' + syncStatusTagType(scope.row.price_sync_status)"
							>{{ formatSyncStatus(scope.row.price_sync_status) }}</span>
							<span v-else class="sync-status-empty">-</span>
						</div>
						<div class="cell-time">{{ formatTime(scope.row.price_sync_time) }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="goods_name" label="商品名称" min-width="160" align="center" class-name="cell-wrap-column">
					<template slot-scope="scope">
						<div class="cell-wrap-full">{{ scope.row.goods_name || '-' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="最近订单时间" min-width="132" align="center">
					<template slot-scope="scope">{{ formatTime(scope.row.last_order_time) }}</template>
				</el-table-column>
				<el-table-column label="创建时间" min-width="132" align="center">
					<template slot-scope="scope">{{ formatTime(scope.row.create_time) }}</template>
				</el-table-column>
				<el-table-column label="数据入库时间" min-width="132" align="center">
					<template slot-scope="scope">{{ formatTime(scope.row.data_create_time) }}</template>
				</el-table-column>
				<el-table-column label="数据更新时间" min-width="132" align="center">
					<template slot-scope="scope">{{ formatTime(scope.row.data_update_time) }}</template>
				</el-table-column>
				<el-table-column label="操作" width="248" align="center" fixed="right">
					<template slot-scope="scope">
						<div class="row-actions">
							<button type="button" class="action-chip" @click="onSkuLog(scope.row)">Sku更新记录</button>
							<button type="button" class="action-chip" @click="onChannelConfig(scope.row)">渠道配置</button>
							<button type="button" class="action-chip" @click="onDeleteRow(scope.row)">删除</button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</section>

		<section class="pager-card">
			<el-pagination
				background
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page"
				:page-size.sync="pageSize"
				:total="total"
				@current-change="handleCurrentChange"
				@size-change="handleSizeChange"
			/>
		</section>
		</template>

		<section v-else-if="pageView === 'ruleConfig'" class="rule-config-panel">
			<div class="rule-config-head">
				<el-button type="primary" size="small" icon="el-icon-arrow-left" class="back-list-btn" @click="closeRuleConfig">返回商品列表</el-button>
				<span v-if="ruleConfigRow" class="rule-config-goods">
					{{ ruleConfigRow.goods_name || ruleConfigRow.goods_id || '' }}
				</span>
			</div>
			<div class="rule-config-body">
				<component :is="ruleConfigComponent" v-if="ruleConfigComponent" :key="ruleConfigKey" />
			</div>
		</section>

		<section v-else-if="pageView === 'channelConfig'" class="rule-config-panel">
			<div class="rule-config-head">
				<el-button type="primary" size="small" icon="el-icon-arrow-left" class="back-list-btn" @click="closeChannelConfig">返回商品列表</el-button>
				<span v-if="channelConfigRow" class="rule-config-goods">
					{{ channelConfigRow.goods_name || channelConfigRow.goods_id || '' }}
				</span>
			</div>
			<div class="rule-config-body">
				<PddGoodsChannelConfig v-if="channelConfigProductId" :key="channelConfigKey" />
			</div>
		</section>

		<section v-else-if="pageView === 'skuLog'" class="rule-config-panel">
			<div class="rule-config-head">
				<el-button type="primary" size="small" icon="el-icon-arrow-left" class="back-list-btn" @click="closeSkuLog">返回商品列表</el-button>
				<span v-if="skuLogRow" class="rule-config-goods">
					{{ skuLogRow.goods_name || skuLogRow.goods_id || '' }}
				</span>
			</div>
			<div class="rule-config-body">
				<PddGoodsSkuLog v-if="skuLogProductId" :key="skuLogKey" />
			</div>
		</section>
	</div>
</template>

<script>
import SafetyStockPriceRule from './detailed/safetyStockPriceRule.vue'
import FixedPriceChannelRule from './detailed/fixedPriceChannelRule.vue'
import PddGoodsChannelConfig from './pddGoodsChannelConfig.vue'
import PddGoodsSkuLog from './pddGoodsSkuLog.vue'
import { PUSH_CONFIG_TYPES } from './detailed/retailShopPushConfig'

export default {
	name: 'StorePddGoods',
	components: {
		SafetyStockPriceRule,
		FixedPriceChannelRule,
		PddGoodsChannelConfig,
		PddGoodsSkuLog,
	},
	provide() {
		return {
			retailShop: this,
			getSyncTaskId: this.getSyncTaskId,
		}
	},
	data() {
		return {
			list: [],
			page: 1,
			pageSize: 20,
			total: 0,
			loading: false,
			shopLoading: false,
			shopList: [],
			selectedRows: [],
			tableHeight: 480,
			pageView: 'list',
			ruleConfigRow: null,
			ruleConfigKey: '',
			ruleConfigView: '',
			channelConfigRow: null,
			skuLogRow: null,
			syncTaskMap: {},
			pushConfigScope: 'shop',
			retailShopProductId: '',
			pushConfigApiType: '',
			shopDetail: null,
			shopDetailLoading: false,
			allShopGoodsCache: null,
			formfilter: {
				retail_shop_id: '',
				goods_status: 1,
				stock_sync: '',
				sync_rule: '',
				auto_order: '',
				is_deleted: '',
				keyword: '',
				tag: '',
				stock_sync_status: '',
				price_sync_status: '',
			},
			goodsStatusOptions: [
				{ label: '商品状态-全部', value: '' },
				{ label: '商品状态-未知', value: 0 },
				{ label: '商品状态-上架', value: 1 },
				{ label: '商品状态-下架', value: 2 },
				{ label: '商品状态-售罄', value: 3 },
				{ label: '商品状态-已删除', value: 4 },
			],
			tagOptions: [
				{ label: '全部', value: '' },
				{ label: '未设置', value: 0 },
			],
			stockSyncStatusOptions: [
				{ label: '全部', value: '' },
				{ label: '待处理', value: 0 },
				{ label: '成功', value: 2 },
				{ label: '失败', value: 3 },
				{ label: '部分成功', value: 4 },
			],
			priceSyncStatusOptions: [
				{ label: '全部', value: '' },
				{ label: '待处理', value: 0 },
				{ label: '成功', value: 2 },
				{ label: '失败', value: 3 },
			],
			syncRuleOptions: [
				{ value: 'manual', label: '同步规则-手工指定' },
				{ value: 'fixed_price_channel_shop', label: '同步规则-一口价选渠道-通用规则' },
				{ value: 'fixed_price_channel_product', label: '同步规则-一口价选渠道-单独规则' },
				{ value: 'safety_stock_price_shop', label: '同步规则-通用安全库存规则改价格' },
				{ value: 'safety_stock_price_product', label: '同步规则-单独安全库存规则改价格' },
				{ value: 'none', label: '同步规则-未设置' },
			],
			syncRuleTableOptions: [
				{ value: 'manual', label: '手工指定' },
				{ value: 'fixed_price_channel_shop', label: '一口价选渠道-通用规则' },
				{ value: 'fixed_price_channel_product', label: '一口价选渠道-单独规则' },
				{ value: 'safety_stock_price_shop', label: '通用安全库存规则改价格' },
				{ value: 'safety_stock_price_product', label: '单独安全库存规则改价格' },
				{ value: 'none', label: '未设置' },
			],
			bulkPrimary: [
				{ key: 'fixed_price_channel_shop', label: '一口价·通用规则' },
				{ key: 'safety_stock_price_shop', label: '安全库存改价·通用' },
				//{ key: 'clear_protect_price', label: '清除SKU保价' },
				{ key: 'download', label: '下载商品' },
				{ key: 'update_info', label: '批量更新信息' },
				//{ key: 'update_stock', label: '批量更新库存' },
				{ key: 'batch_onsale', label: '批量上架' },
				{ key: 'restore', label: '删除恢复' },
			],
			bulkSecondary: [
				{ key: 'fixed_price_channel_product', label: '一口价·单独规则' },
				{ key: 'safety_stock_price_product', label: '安全库存改价·单独' },
			],
		}
	},
	computed: {
		currentShopId() {
			return this.formfilter.retail_shop_id || sessionStorage.getItem('retailShopId') || ''
		},
		shopName() {
			return (this.shopDetail && this.shopDetail.mall_name) || ''
		},
		pushConfigKey() {
			if (this.pageView !== 'ruleConfig') {
				return ''
			}
			return [
				this.pushConfigScope,
				this.retailShopProductId,
				this.pushConfigApiType,
				this.ruleConfigView,
			].join(':')
		},
		ruleConfigComponent() {
			if (this.ruleConfigView === 'fixed_price') {
				return 'FixedPriceChannelRule'
			}
			if (this.ruleConfigView === 'safety_stock') {
				return 'SafetyStockPriceRule'
			}
			return null
		},
		channelConfigProductId() {
			if (this.pageView !== 'channelConfig' || !this.channelConfigRow) {
				return ''
			}
			return String(this.channelConfigRow.id || '')
		},
		channelConfigKey() {
			if (this.pageView !== 'channelConfig') {
				return ''
			}
			return [
				this.channelConfigProductId,
				this.formfilter.retail_shop_id,
			].join('-')
		},
		skuLogProductId() {
			if (this.pageView !== 'skuLog' || !this.skuLogRow) {
				return ''
			}
			return String(this.skuLogRow.id || '')
		},
		skuLogKey() {
			if (this.pageView !== 'skuLog') {
				return ''
			}
			return [
				this.skuLogProductId,
				this.formfilter.retail_shop_id,
			].join('-')
		},
		currentShopName() {
			var shop = this.shopList.find(function(item) {
				return String(item.id) === String(this.formfilter.retail_shop_id)
			}.bind(this))
			return shop ? (shop.mall_name || shop.shop_name || '') : ''
		},
	},
	mounted() {
		this.initPage()
		this.syncPageFromRoute(this.$route)
		this.calcTableHeight()
		window.addEventListener('resize', this.calcTableHeight)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.calcTableHeight)
	},
	watch: {
		'$route'(to) {
			this.syncPageFromRoute(to)
		},
	},
	methods: {
		initPage() {
			// 列表店铺筛选默认「全部」，不从 session 回填；子页由 syncPageFromRoute 处理
			this.fetchShopList()
		},
		parseShopList(data) {
			if (Array.isArray(data)) {
				return data
			}
			if (data && Array.isArray(data.list)) {
				return data.list
			}
			return []
		},
		calcTableHeight() {
			this.$nextTick(function() {
				var card = this.$refs.tableCard
				if (!card) return
				var h = card.getBoundingClientRect().height
				this.tableHeight = h > 360 ? Math.floor(h) : 360
			}.bind(this))
		},
		indexMethod(index) {
			return (this.page - 1) * this.pageSize + index + 1
		},
		onfilter() {
			this.page = 1
			this.allShopGoodsCache = null
			this.fetchList()
		},
		onreset() {
			this.formfilter = {
				retail_shop_id: '',
				goods_status: 1,
				stock_sync: '',
				sync_rule: '',
				auto_order: '',
				is_deleted: '',
				keyword: '',
				tag: '',
				stock_sync_status: '',
				price_sync_status: '',
			}
			this.page = 1
			this.allShopGoodsCache = null
			this.fetchList()
		},
		onShopChange() {
			if (this.formfilter.retail_shop_id) {
				sessionStorage.setItem('retailShopId', String(this.formfilter.retail_shop_id))
			} else {
				sessionStorage.removeItem('retailShopId')
			}
			this.page = 1
			this.allShopGoodsCache = null
			this.fetchList()
		},
		handleCurrentChange(val) {
			this.page = val
			if (!this.formfilter.retail_shop_id && this.allShopGoodsCache) {
				this.applyAllShopPage()
				return
			}
			this.fetchList()
		},
		handleSizeChange(val) {
			this.pageSize = val
			this.page = 1
			if (!this.formfilter.retail_shop_id && this.allShopGoodsCache) {
				this.applyAllShopPage()
				return
			}
			this.fetchList()
		},
		handleSelectionChange(val) {
			this.selectedRows = val || []
		},
		fetchShopList() {
			this.shopLoading = true
			this.$axios.post('api/retail_shop/list', { page: 1, limit: 9999 }).then(function(res) {
				if (res.data.code == 0) {
					this.shopList = this.parseShopList(res.data.data)
				} else {
					this.$message.error(res.data.message || '获取店铺失败')
				}
			}.bind(this)).catch(function(err) {
				console.log(err)
				this.$message.error('获取店铺失败')
			}.bind(this)).finally(function() {
				this.shopLoading = false
				this.fetchList()
			}.bind(this))
		},
		buildFilterParams() {
			var p = {}
			var goodsStatus = this.formfilter.goods_status
			if (goodsStatus !== '' && goodsStatus != null) {
				p.goods_status = Number(goodsStatus)
			}
			if (this.formfilter.sync_rule) {
				p.sync_rule = this.formfilter.sync_rule
			}
			var stockSync = this.formfilter.stock_sync
			if (stockSync !== '' && stockSync != null) {
				p.stock_sync = Number(stockSync)
			}
			var autoOrder = this.formfilter.auto_order
			if (autoOrder !== '' && autoOrder != null) {
				p.auto_order = Number(autoOrder)
			}
			var isDeleted = this.formfilter.is_deleted
			if (isDeleted !== '' && isDeleted != null) {
				p.is_deleted = Number(isDeleted)
			}
			var keyword = (this.formfilter.keyword || '').trim()
			if (keyword) {
				p.keyword = keyword
			}
			var stockSyncStatus = this.formfilter.stock_sync_status
			if (stockSyncStatus !== '' && stockSyncStatus != null) {
				p.stock_sync_status = Number(stockSyncStatus)
			}
			var priceSyncStatus = this.formfilter.price_sync_status
			if (priceSyncStatus !== '' && priceSyncStatus != null) {
				p.price_sync_status = Number(priceSyncStatus)
			}
			return p
		},
		buildListParams() {
			var shopId = Number(this.formfilter.retail_shop_id)
			if (!shopId || isNaN(shopId)) {
				return null
			}
			return Object.assign(this.buildFilterParams(), {
				retail_shop_id: shopId,
				page: this.page,
				limit: this.pageSize,
			})
		},
		parseListResponse(data) {
			if (!data) {
				return { list: [], count: 0 }
			}
			if (Array.isArray(data)) {
				return { list: data, count: data.length }
			}
			return {
				list: Array.isArray(data.list) ? data.list : [],
				count: data.count != null ? data.count : (data.total_count != null ? data.total_count : (data.total || 0)),
			}
		},
		applyAllShopPage() {
			var all = this.allShopGoodsCache || []
			this.total = all.length
			var start = (this.page - 1) * this.pageSize
			this.list = all.slice(start, start + this.pageSize)
			this.calcTableHeight()
		},
		fetchListAllShops() {
			if (!this.shopList.length) {
				this.allShopGoodsCache = []
				this.list = []
				this.total = 0
				return
			}
			this.loading = true
			var filterParams = this.buildFilterParams()
			var requests = this.shopList.map(function(shop) {
				var shopId = Number(shop.id)
				var params = Object.assign({}, filterParams, {
					retail_shop_id: shopId,
					page: 1,
					limit: 9999,
				})
				return this.$axios.post('api/retail_shop/product_list', params).then(function(res) {
					return { shopId: shopId, res: res }
				})
			}.bind(this))
			Promise.all(requests).then(function(results) {
				var all = []
				var firstError = ''
				results.forEach(function(item) {
					var res = item.res
					if (res.data.code == 0) {
						var parsed = this.parseListResponse(res.data.data)
						parsed.list.forEach(function(row) {
							if (row && (row.retail_shop_id == null || row.retail_shop_id === '')) {
								row.retail_shop_id = item.shopId
							}
							all.push(row)
						})
					} else if (!firstError) {
						firstError = res.data.message || '获取商品列表失败'
					}
				}.bind(this))
				if (firstError && !all.length) {
					this.$message.error(firstError)
				}
				this.allShopGoodsCache = all
				this.applyAllShopPage()
			}.bind(this)).catch(function(err) {
				console.log(err)
				this.$message.error('获取商品列表失败')
			}.bind(this)).finally(function() {
				this.loading = false
				this.calcTableHeight()
			}.bind(this))
		},
		fetchList() {
			if (!this.formfilter.retail_shop_id) {
				this.fetchListAllShops()
				return
			}
			this.allShopGoodsCache = null
			var params = this.buildListParams()
			if (!params) {
				this.list = []
				this.total = 0
				return
			}
			this.loading = true
			var shopId = params.retail_shop_id
			this.$axios.post('api/retail_shop/product_list', params).then(function(res) {
				if (res.data.code == 0) {
					var parsed = this.parseListResponse(res.data.data)
					parsed.list.forEach(function(row) {
						if (row && (row.retail_shop_id == null || row.retail_shop_id === '')) {
							row.retail_shop_id = shopId
						}
					})
					this.list = parsed.list
					this.total = parsed.count
				} else {
					this.$message.error(res.data.message || '获取商品列表失败')
				}
			}.bind(this)).catch(function(err) {
				console.log(err)
				this.$message.error('获取商品列表失败')
			}.bind(this)).finally(function() {
				this.loading = false
				this.calcTableHeight()
			}.bind(this))
		},
		requireSelection() {
			if (!this.selectedRows.length) {
				this.$message.warning('请先选择商品')
				return false
			}
			return true
		},
		getSelectedIds() {
			return this.selectedRows.map(function(row) {
				return row.id || row.goods_id
			}).filter(Boolean)
		},
		getSelectedProductIds() {
			return this.selectedRows.map(function(row) {
				return row.id
			}).filter(Boolean).map(Number)
		},
		groupSelectedRowsByShop(rows) {
			var groups = []
			var map = {}
			var skippedNoShop = 0
			;(rows || []).forEach(function(row) {
				var raw = row && (row.retail_shop_id != null && row.retail_shop_id !== ''
					? row.retail_shop_id
					: row.shop_id)
				var shopId = Number(raw)
				if (!shopId || isNaN(shopId)) {
					skippedNoShop += 1
					return
				}
				var key = String(shopId)
				if (!map[key]) {
					map[key] = { shopId: shopId, rows: [] }
					groups.push(map[key])
				}
				map[key].rows.push(row)
			})
			return { groups: groups, skippedNoShop: skippedNoShop }
		},
		onBulkAction(action) {
			if (action.key === 'download') {
				this.onDownloadProducts()
				return
			}
			if (action.key === 'update_info') {
				this.onBatchUpdateInfo()
				return
			}
			if (!this.requireSelection()) return
			if (action.key === 'fixed_price_channel_shop' || action.key === 'safety_stock_price_shop') {
				this.onBatchPushStrategy(action.key)
				return
			}
			if (action.key === 'restore') {
				this.$axios.post('api/retail_goods/restore', {
					retail_shop_product_ids: this.getSelectedProductIds(),
				}).then(function(res) {
					if (res.data.code == 0) {
						this.$message.success('操作成功')
						this.fetchList()
					} else {
						this.$message.error(res.data.message || '操作失败')
					}
				}.bind(this)).catch(function() {
					this.$message.error('操作失败')
				}.bind(this))
				return
			}
			if (action.key === 'batch_onsale') {
				this.onBatchOnsale()
				return
			}
			this.$axios.post('api/retail_goods/batch_action', {
				retail_shop_id: this.formfilter.retail_shop_id,
				goods_ids: this.getSelectedIds(),
				action: action.key,
			}).then(function(res) {
				if (res.data.code == 0) {
					this.$message.success('操作成功')
					this.fetchList()
				} else {
					this.$message.error(res.data.message || '操作失败')
				}
			}.bind(this)).catch(function() {
				this.$message.error('操作失败')
			}.bind(this))
		},
		onDownloadProducts() {
			var shopId = Number(this.formfilter.retail_shop_id)
			if (!shopId || isNaN(shopId)) {
				this.$message.warning('请先选择店铺')
				return
			}
			var productIds = this.getSelectedProductIds()
			this.$axios.post('api/retail_goods/download_goods', {
				retail_shop_id: shopId,
				product_ids: productIds.length ? productIds : '',
			}).then(function(res) {
				if (res.data.code == 0) {
					this.$message.success('操作成功')
					this.fetchList()
				} else {
					this.$message.error(res.data.message || '操作失败')
				}
			}.bind(this)).catch(function() {
				this.$message.error('操作失败')
			}.bind(this))
		},
		getSyncTaskId(productId) {
			if (!productId) {
				return 0
			}
			return this.syncTaskMap[String(productId)] || 0
		},
		onBatchUpdateInfo() {
			var selected = this.selectedRows || []
			var self = this
			if (selected.length) {
				var grouped = this.groupSelectedRowsByShop(selected)
				if (grouped.skippedNoShop) {
					this.$message.warning('已跳过 ' + grouped.skippedNoShop + ' 条缺少店铺的商品')
				}
				if (!grouped.groups.length) {
					this.$message.warning('勾选商品没有所属店铺')
					return
				}
				var requests = grouped.groups.map(function(group) {
					var ids = group.rows.map(function(row) {
						return Number(row.id)
					}).filter(function(id) {
						return id > 0
					})
					return self.$axios.post('api/retail_goods/sync_trigger', {
						retail_shop_id: group.shopId,
						product_ids: ids,
					})
				})
				Promise.all(requests).then(function(results) {
					var totalTasks = 0
					var requestError = ''
					results.forEach(function(res) {
						if (res.data.code != 0) {
							requestError = res.data.message || '操作失败'
							return
						}
						var tasks = (res.data.data && res.data.data.tasks) || []
						tasks.forEach(function(t) {
							if (t && t.retail_shop_product_id > 0 && t.task_id) {
								self.syncTaskMap[String(t.retail_shop_product_id)] = t.task_id
							}
						})
						totalTasks += tasks.length
					})
					if (requestError && totalTasks === 0) {
						self.$message.error(requestError)
						return
					}
					var shopNote = grouped.groups.length > 1 ? '（' + grouped.groups.length + ' 个店铺）' : ''
					var msg = totalTasks
						? '已为 ' + totalTasks + ' 个商品触发同步' + shopNote + '，可在 Sku更新记录 查看结果'
						: '操作成功'
					self.$message.success(msg)
					self.fetchList()
				}).catch(function() {
					self.$message.error('操作失败')
				})
				return
			}
			var shopId = Number(this.formfilter.retail_shop_id)
			if (!shopId || isNaN(shopId)) {
				this.$message.warning('请先选择店铺')
				return
			}
			this.$axios.post('api/retail_goods/sync_trigger', {
				retail_shop_id: shopId,
				product_ids: '',
			}).then(function(res) {
				if (res.data.code == 0) {
					var tasks = (res.data.data && res.data.data.tasks) || []
					tasks.forEach(function(t) {
						if (t && t.retail_shop_product_id > 0 && t.task_id) {
							this.syncTaskMap[String(t.retail_shop_product_id)] = t.task_id
						}
					}.bind(this))
					var msg = tasks.length
						? '已为 ' + tasks.length + ' 个商品触发同步，可在 Sku更新记录 查看结果'
						: '操作成功'
					this.$message.success(msg)
					this.fetchList()
				} else {
					this.$message.error(res.data.message || '操作失败')
				}
			}.bind(this)).catch(function() {
				this.$message.error('操作失败')
			}.bind(this))
		},
		onBatchOnsale() {
			if (!this.requireSelection()) {
				return
			}
			var grouped = this.groupSelectedRowsByShop(this.selectedRows)
			if (grouped.skippedNoShop) {
				this.$message.warning('已跳过 ' + grouped.skippedNoShop + ' 条缺少店铺的商品')
			}
			if (!grouped.groups.length) {
				this.$message.warning('勾选商品没有所属店铺')
				return
			}
			var self = this
			var requests = grouped.groups.map(function(group) {
				var ids = group.rows.map(function(row) {
					return Number(row.id)
				}).filter(function(id) {
					return id > 0
				})
				return self.$axios.post('api/retail_goods/batch_set_sale_status', {
					retail_shop_id: group.shopId,
					product_ids: ids,
					is_onsale: 1,
				})
			})
			Promise.all(requests).then(function(results) {
				var requestError = ''
				var ok = 0
				results.forEach(function(res) {
					if (res.data.code != 0) {
						requestError = res.data.message || '操作失败'
						return
					}
					ok += 1
				})
				if (requestError && ok === 0) {
					self.$message.error(requestError)
					return
				}
				self.$message.success('操作成功')
				self.fetchList()
			}).catch(function() {
				self.$message.error('操作失败')
			})
		},
		onBatchPushStrategy(pushStrategy) {
			var productIds = this.getSelectedProductIds()
			if (!productIds.length) {
				this.$message.warning('请先选择商品')
				return
			}
			this.$axios.post('api/retail_shop/product_push_strategy_save', {
				id: productIds,
				push_strategy: pushStrategy,
			}).then(function(res) {
				if (res.data.code == 0) {
					this.$message.success('操作成功')
					this.fetchList()
				} else {
					this.$message.error(res.data.message || '操作失败')
				}
			}.bind(this)).catch(function() {
				this.$message.error('操作失败')
			}.bind(this))
		},
		onSyncRuleChange(row) {
			if (!row || !row.id) {
				this.$message.warning('商品信息不完整')
				this.fetchList()
				return
			}
			this.$axios.post('api/retail_shop/product_push_strategy_save', {
				id: row.id,
				push_strategy: row.sync_rule,
			}).then(function(res) {
				if (res.data.code == 0) {
					this.$message.success('同步规则已更新')
				} else {
					this.$message.error(res.data.message || '更新失败')
					this.fetchList()
				}
			}.bind(this)).catch(function() {
				this.$message.error('更新失败')
				this.fetchList()
			}.bind(this))
		},
		getStockSyncValue(row) {
			if (!row || row.stock_sync == null || row.stock_sync === '') {
				return 0
			}
			return Number(row.stock_sync)
		},
		formatStockSyncText(row) {
			if (row && row.stock_sync_label) {
				return row.stock_sync_label
			}
			return this.getStockSyncValue(row) === 1 ? '同步' : '不同步'
		},
		onStockSyncChange(row, value) {
			if (!row || !row.id) {
				this.$message.warning('商品信息不完整')
				return
			}
			var prev = this.getStockSyncValue(row)
			var nextValue = Number(value)
			row.stock_sync = nextValue
			this.$axios.post('api/retail_goods/product_update', {
				retail_shop_product_id: Number(row.id),
				is_sync: nextValue,
			}).then(function(res) {
				if (res.data.code == 0) {
					this.$message.success('同步库存状态已更新')
				} else {
					this.$message.error(res.data.message || '更新失败')
					row.stock_sync = prev
				}
			}.bind(this)).catch(function() {
				this.$message.error('更新失败')
				row.stock_sync = prev
			}.bind(this))
		},
		showRuleConfigBtn(row) {
			var syncRule = row && row.sync_rule
			return syncRule && syncRule !== 'manual' && syncRule !== 'none'
		},
		resolveRuleConfigView(syncRule) {
			if (syncRule === 'fixed_price_channel_shop' || syncRule === 'fixed_price_channel_product') {
				return 'fixed_price'
			}
			if (syncRule === 'safety_stock_price_shop' || syncRule === 'safety_stock_price_product') {
				return 'safety_stock'
			}
			return ''
		},
		isProductPushConfig(syncRule) {
			return syncRule === 'fixed_price_channel_product' || syncRule === 'safety_stock_price_product'
		},
		resolvePushConfigApiType(syncRule) {
			if (syncRule === 'fixed_price_channel_shop' || syncRule === 'fixed_price_channel_product') {
				return PUSH_CONFIG_TYPES.FIXED_PRICE_CHANNEL
			}
			if (syncRule === 'safety_stock_price_shop' || syncRule === 'safety_stock_price_product') {
				return PUSH_CONFIG_TYPES.SAFETY_STOCK_PRICE
			}
			return ''
		},
		onRuleConfig(row) {
			if (!row || !this.showRuleConfigBtn(row)) {
				return
			}
			var shopId = this.resolveRowShopId(row)
			if (!shopId) {
				this.$message.warning('商品缺少店铺信息')
				return
			}
			var syncRule = row.sync_rule
			var ruleConfigView = this.resolveRuleConfigView(syncRule)
			if (!ruleConfigView) {
				this.$message.warning('当前同步规则暂不支持参数配置')
				return
			}
			sessionStorage.setItem('retailShopId', String(shopId))
			this.ruleConfigRow = row
			this.ruleConfigView = ruleConfigView
			this.pushConfigScope = this.isProductPushConfig(syncRule) ? 'product' : 'shop'
			this.retailShopProductId = this.pushConfigScope === 'product' ? String(row.id) : ''
			this.pushConfigApiType = this.resolvePushConfigApiType(syncRule)
			this.fetchShopDetail(shopId, true)
			this.ruleConfigKey = [
				this.pushConfigScope,
				this.retailShopProductId || shopId,
				this.pushConfigApiType,
				row.goods_id || row.id,
			].join('-')
			this.channelConfigRow = null
			this.pageView = 'ruleConfig'
		},
		closeRuleConfig() {
			this.pageView = 'list'
			this.ruleConfigRow = null
			this.ruleConfigView = ''
			this.pushConfigScope = 'shop'
			this.retailShopProductId = ''
			this.pushConfigApiType = ''
		},
		fetchShopDetail(id, force) {
			var shopId = String(id || '')
			if (!shopId) {
				return
			}
			if (!force && this.shopDetail && String(this.shopDetail.id) === shopId) {
				return
			}
			this.shopDetailLoading = true
			this.$axios.post('api/retail_shop/detail', { id: shopId }).then(function(res) {
				if (res.data.code == 0) {
					this.shopDetail = res.data.data || null
				} else {
					this.$message.error(res.data.message || '获取店铺详情失败')
				}
			}.bind(this)).catch(function() {
				this.$message.error('获取店铺详情失败')
			}.bind(this)).finally(function() {
				this.shopDetailLoading = false
			}.bind(this))
		},
		resolveRowShopId(row) {
			var fromRow = ''
			if (row) {
				if (row.retail_shop_id != null && row.retail_shop_id !== '') {
					fromRow = row.retail_shop_id
				} else if (row.shop_id != null && row.shop_id !== '') {
					fromRow = row.shop_id
				}
			}
			return String(fromRow || this.formfilter.retail_shop_id || '')
		},
		onSkuLog(row) {
			if (!row || !row.id) {
				this.$message.warning('商品信息不完整')
				return
			}
			var shopId = this.resolveRowShopId(row)
			if (!shopId) {
				this.$message.warning('商品缺少店铺信息')
				return
			}
			sessionStorage.setItem('retailShopId', String(shopId))
			this.$router.push({
				path: '/StoreConfig/pddGoods/sku/' + row.id,
				query: {
					shop_id: shopId,
					goods_id: row.goods_id || '',
					goods_name: row.goods_name || '',
				},
			})
		},
		syncPageFromRoute(route) {
			if (!route) {
				return
			}
			var productId = route.params && route.params.productId
			if (productId && route.path.indexOf('/pddGoods/sku/') !== -1) {
				var skuShopId = route.query.shop_id || this.formfilter.retail_shop_id || sessionStorage.getItem('retailShopId') || ''
				if (skuShopId) {
					this.formfilter.retail_shop_id = String(skuShopId)
					sessionStorage.setItem('retailShopId', String(skuShopId))
				}
				this.openSkuLogById(productId, route.query || {})
				return
			}
			if (productId && route.path.indexOf('/pddGoods/channel/') !== -1) {
				var shopId = route.query.shop_id || this.formfilter.retail_shop_id || sessionStorage.getItem('retailShopId') || ''
				if (shopId) {
					this.formfilter.retail_shop_id = String(shopId)
					sessionStorage.setItem('retailShopId', String(shopId))
				}
				this.openChannelConfigById(productId, route.query || {})
				return
			}
			if (this.pageView === 'channelConfig') {
				this.resetChannelConfigState()
			}
			if (this.pageView === 'skuLog') {
				this.resetSkuLogState()
			}
		},
		openSkuLogById(productId, query) {
			var row = this.list.find(function(item) {
				return String(item.id) === String(productId)
			})
			if (!row) {
				row = {
					id: productId,
					goods_id: query.goods_id || '',
					goods_name: query.goods_name || '',
					retail_shop_id: query.shop_id || '',
				}
			}
			this.ruleConfigRow = null
			this.ruleConfigView = ''
			this.channelConfigRow = null
			this.skuLogRow = row
			this.pageView = 'skuLog'
		},
		resetSkuLogState() {
			this.pageView = 'list'
			this.skuLogRow = null
		},
		closeSkuLog() {
			if (this.$route.path.indexOf('/pddGoods/sku/') !== -1) {
				this.$router.push('/StoreConfig/pddGoods')
				return
			}
			this.resetSkuLogState()
		},
		openChannelConfigById(productId, query) {
			var row = this.list.find(function(item) {
				return String(item.id) === String(productId)
			})
			if (!row) {
				row = {
					id: productId,
					goods_id: query.goods_id || '',
					goods_name: query.goods_name || '',
					sync_rule: query.sync_rule || 'fixed_price_channel_product',
					retail_shop_id: query.shop_id || '',
				}
			}
			this.ruleConfigRow = null
			this.ruleConfigView = ''
			this.skuLogRow = null
			this.channelConfigRow = row
			this.pageView = 'channelConfig'
			if (this.formfilter.retail_shop_id) {
				this.fetchShopDetail(this.formfilter.retail_shop_id, true)
			}
		},
		resetChannelConfigState() {
			this.pageView = 'list'
			this.channelConfigRow = null
		},
		onChannelConfig(row) {
			if (!row || !row.id) {
				this.$message.warning('商品信息不完整')
				return
			}
			var shopId = this.resolveRowShopId(row)
			if (!shopId) {
				this.$message.warning('商品缺少店铺信息')
				return
			}
			sessionStorage.setItem('retailShopId', String(shopId))
			this.$router.push({
				path: '/StoreConfig/pddGoods/channel/' + row.id,
				query: {
					shop_id: shopId,
					goods_id: row.goods_id || '',
					goods_name: row.goods_name || '',
					sync_rule: row.sync_rule || '',
				},
			})
		},
		closeChannelConfig() {
			if (this.$route.path.indexOf('/pddGoods/channel/') !== -1) {
				this.$router.push('/StoreConfig/pddGoods')
				return
			}
			this.resetChannelConfigState()
		},
		onDeleteRow(row) {
			if (!row || !row.id) {
				this.$message.warning('商品信息不完整')
				return
			}
			this.$axios.post('api/retail_goods/delete', {
				retail_shop_product_id: Number(row.id),
			}).then(function(res) {
				if (res.data.code == 0) {
					this.$message.success('删除成功')
					this.fetchList()
				} else {
					this.$message.error(res.data.message || '删除失败')
				}
			}.bind(this)).catch(function() {
				this.$message.error('删除失败')
			}.bind(this))
		},
		splitSkuCode(value) {
			if (!value) return []
			return String(value).split(/[;|]/).map(function(item) {
				return item.trim()
			}).filter(Boolean)
		},
		formatSkuCodeText(value) {
			return this.splitSkuCode(value).join(';')
		},
		splitStyleNumber(value) {
			return this.splitSkuCode(value)
		},
		displayCell(value) {
			if (value == null || value === '') {
				return '-'
			}
			return value
		},
		getGoodsStatusValue(row) {
			if (!row || row.goods_status == null || row.goods_status === '') {
				return ''
			}
			return Number(row.goods_status)
		},
		formatGoodsStatus(row) {
			if (row && row.goods_status_label) {
				return row.goods_status_label
			}
			var value = this.getGoodsStatusValue(row)
			if (value === 0) return '未知'
			if (value === 1) return '上架'
			if (value === 2) return '下架'
			if (value === 3) return '售罄'
			if (value === 4) return '已删除'
			return '-'
		},
		goodsStatusClass(row) {
			var value = this.getGoodsStatusValue(row)
			if (value === 0) return 'is-unknown'
			if (value === 1) return 'is-on'
			if (value === 2) return 'is-off'
			if (value === 3) return 'is-soldout'
			if (value === 4) return 'is-deleted'
			return 'is-unknown'
		},
		formatAutoOrderRow(row) {
			if (row && row.auto_order_label) {
				return row.auto_order_label
			}
			if (row && row.auto_order == 1) return '自动下单'
			if (row && row.auto_order == 0) return '手动下单'
			return '-'
		},
		formatSyncStatus(v) {
			if (v == null || v === '') return '-'
			if (typeof v === 'string') return v
			if (v == 2) return '成功'
			if (v == 3) return '失败'
			if (v == 4) return '部分成功'
			if (v == 0) return '待处理'
			return String(v)
		},
		syncStatusTagType(v) {
			var text = this.formatSyncStatus(v)
			if (text === '部分成功' || text === '同步部分' || text === '同步中') return 'warning'
			if (text === '成功' || text === '同步成功') return 'success'
			if (text === '失败' || text === '同步失败') return 'danger'
			return 'info'
		},
		formatTime(v) {
			if (v == null || v === '') return '-'
			if (typeof v === 'string' && v.indexOf('-') !== -1) {
				return v
			}
			return this.$moment.unix(Number(v)).format('YYYY-MM-DD HH:mm:ss')
		},
	},
}
</script>

<style scoped lang="less">
@import './storeTable.less';

.pdd-goods-page {
	height: 100%;
	min-height: calc(100vh - 62px);
	padding: 8px 12px 0;
	box-sizing: border-box;
	background: linear-gradient(180deg, #f7f9fc 0%, #f3f5f8 100%);
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.rule-config-panel {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	background: #fff;
	border-radius: 10px;
	box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
	overflow: hidden;
}

.rule-config-head {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 14px;
	border-bottom: 1px solid #eef0f3;
	background: #fff;

	.back-list-btn {
		font-weight: 500;
		padding: 8px 16px;
		box-shadow: 0 2px 8px rgba(246, 87, 48, 0.28);

		/deep/ &.el-button--primary {
			background-color: #ff4714 !important;
			border-color: #ff4714 !important;
		}

		/deep/ &.el-button--primary:hover,
		/deep/ &.el-button--primary:focus {
			background-color: #ff5c2e !important;
			border-color: #ff5c2e !important;
		}
	}
}

.rule-config-goods {
	font-size: 13px;
	color: #606266;
}

.rule-config-body {
	flex: 1;
	min-height: 0;
	overflow: auto;
}

.filter-card,
.toolbar-card,
.table-card,
.pager-card {
	background: #fff;
	border-radius: 10px;
	box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
	transition: box-shadow 0.25s ease, transform 0.25s ease;

	&:hover {
		box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
	}
}

.filter-card {
	padding: 10px 14px 8px;
	flex-shrink: 0;
	font-size: 12px;
}

.filter-row {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: 8px;
	width: 100%;

	&--second {
		margin-top: 6px;
	}
}

.filter-actions {
	display: flex;
	align-items: center;
	flex: 0 0 152px;
	justify-content: flex-end;
	gap: 6px;
	margin-bottom: 0;

	/deep/ .el-button {
		padding: 7px 12px;
		font-size: 12px;
	}
}

.btn-search {
	background: linear-gradient(135deg, #ff6b3d 0%, #ff4714 100%) !important;
	border: none !important;
	box-shadow: 0 4px 12px rgba(255, 71, 20, 0.28);
	transition: transform 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 6px 16px rgba(255, 71, 20, 0.34);
	}
}

.btn-ghost {
	color: #606266;
	border-color: #e4e7ed;
	background: #fafbfc;
	transition: all 0.2s ease;

	&:hover {
		color: #ff4714;
		border-color: rgba(255, 71, 20, 0.35);
		background: rgba(255, 71, 20, 0.04);
	}
}

.filter-form {
	display: block;
	width: 100%;

	/deep/ &.el-form--inline .filter-row > .el-form-item {
		display: block;
	}

	.filter-row > .el-form-item {
		flex: 1;
		min-width: 0;
		margin-bottom: 0;
		margin-right: 0;
	}

	.filter-row--second > .keyword-item {
		flex: 1;
		min-width: 0;

		&:first-child {
			flex: 1.8;
		}
	}

	/deep/ .el-form-item__content {
		width: 100%;
	}

	/deep/ .el-input__inner,
	/deep/ .el-input__icon {
		font-size: 12px;
	}

	/deep/ .el-input__inner {
		height: 30px;
		line-height: 30px;
	}

	.filter-control {
		width: 100%;
	}

	.keyword-item {
		/deep/ .el-form-item__content {
			display: flex;
			align-items: center;
			gap: 6px;
		}

		/deep/ .el-input,
		/deep/ .el-select {
			flex: 1;
			min-width: 0;
		}
	}

	.keyword-label {
		flex-shrink: 0;
		font-size: 12px;
		color: #606266;
		white-space: nowrap;
	}

	.keyword-input,
	.labeled-select {
		width: 100%;
	}
}

.toolbar-card {
	padding: 10px 14px;
	flex-shrink: 0;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px 20px;
}

.toolbar-group {
	display: flex;
	align-items: center;
	gap: 10px;
	min-width: 0;
}

.toolbar-label {
	flex-shrink: 0;
	font-size: 12px;
	color: #909399;
	padding: 2px 8px;
	border-radius: 999px;
	background: #f4f6f8;
}

.toolbar-btns {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.tool-btn {
	border: none;
	outline: none;
	padding: 5px 12px;
	font-size: 12px;
	line-height: 1.4;
	border-radius: 6px;
	cursor: pointer;
	color: #fff;
	transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;

	&:hover {
		transform: translateY(-1px);
		opacity: 0.92;
	}

	&:active {
		transform: translateY(0);
	}

	&--brand {
		background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%);
		box-shadow: 0 2px 8px rgba(13, 148, 136, 0.25);
	}

	&--blue {
		background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
		box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
	}
}

.selection-tip {
	margin-left: auto;
	font-size: 12px;
	color: #606266;
	padding: 4px 10px;
	border-radius: 999px;
	background: rgba(255, 71, 20, 0.08);

	strong {
		color: #ff4714;
	}
}

.table-card {
	flex: 1;
	min-height: 0;
	padding: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.goods-table {
	.store-table-border();
	flex: 1;
	min-height: 0;
	font-size: 13px;
	color: #303133;

	&::before {
		height: 0;
	}

	/deep/ thead {
		font-weight: normal;
	}

	/deep/ th.el-table__cell {
		background: #fafbfc;
		color: #606266;
		font-size: 13px;
		font-weight: normal;
		padding: 10px 0;

		.cell {
			font-size: 13px;
			font-weight: normal;
			line-height: 1.5;
		}
	}

	/deep/ td.el-table__cell {
		padding: 10px 0;
		font-size: 13px;

		.cell {
			font-size: 13px;
			font-weight: normal;
			line-height: 1.5;
		}
	}

	/deep/ td.cell-wrap-column .cell {
		white-space: normal;
		word-break: break-all;
		overflow: visible;
		text-overflow: clip;
	}

	/deep/ tr:hover > td.el-table__cell {
		background: #fafbfc !important;
	}

	/deep/ .el-table__empty-text {
		font-size: 13px;
		font-weight: normal;
		color: #909399;
	}
}

.thumb {
	width: 48px;
	height: 48px;
	margin: 0 auto;
	border-radius: 8px;
	overflow: hidden;
	background: #f4f6f8;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	i {
		font-size: 20px;
		color: #c0c4cc;
	}
}

.cell-wrap-full {
	white-space: normal;
	word-break: break-all;
	line-height: 1.5;
}

.cell-main {
	font-weight: normal;
	color: #303133;
}

.cell-sub {
	font-size: 13px;
	color: #909399;
	line-height: 1.4;
}

.cell-sub-ellipsis {
	display: inline-block;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	vertical-align: top;
	cursor: default;
}

.cell-time {
	font-size: 13px;
	color: #909399;
	margin-top: 2px;
}

.status-tag {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 999px;
	font-size: 13px;

	&.is-on {
		color: #059669;
		background: rgba(5, 150, 105, 0.1);
	}

	&.is-off {
		color: #6b7280;
		background: #f3f4f6;
	}

	&.is-soldout {
		color: #d97706;
		background: rgba(217, 119, 6, 0.1);
	}

	&.is-deleted {
		color: #dc2626;
		background: rgba(220, 38, 38, 0.1);
	}

	&.is-unknown {
		color: #9ca3af;
		background: #f9fafb;
	}
}

.sync-status-column /deep/ .cell {
	overflow: visible !important;
	text-overflow: clip !important;
}

.sync-status-cell {
	margin-bottom: 4px;
	line-height: 24px;
}

.sync-status-tag {
	display: inline-block;
	padding: 0 8px;
	height: 24px;
	line-height: 22px;
	font-size: 13px;
	border-radius: 4px;
	border: 1px solid transparent;
	box-sizing: border-box;
	white-space: nowrap;
	vertical-align: middle;
}

.sync-status-tag--success {
	color: #67c23a;
	background: #f0f9eb;
	border-color: #c2e7b0;
}

.sync-status-tag--danger {
	color: #f56c6c;
	background: #fef0f0;
	border-color: #fbc4c4;
}

.sync-status-tag--warning {
	color: #e6a23c;
	background: #fdf6ec;
	border-color: #f5dab1;
}

.sync-status-tag--info {
	color: #909399;
	background: #f4f4f5;
	border-color: #d3d4d6;
}

.sync-status-empty {
	color: #909399;
	font-size: 13px;
}

.status-cell {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 4px 12px 4px 8px;
	border-radius: 20px;
	transition: background 0.2s;

	/deep/ .el-switch {
		height: 20px;
		line-height: 20px;

		.el-switch__core {
			width: 36px !important;
			height: 20px;
			border-radius: 10px;

			&::after {
				width: 16px;
				height: 16px;
			}
		}

		&.is-checked .el-switch__core::after {
			margin-left: -17px;
		}
	}

	.status-label {
		font-size: 12px;
		line-height: 1;
		white-space: nowrap;
	}

	&.is-on {
		background: rgba(255, 71, 20, 0.1);

		.status-label {
			color: #ff4714;
		}
	}

	&.is-off {
		background: #f5f6f8;

		.status-label {
			color: #909399;
		}
	}
}

.rule-select {
	width: 130px;
	margin-bottom: 4px;
}

.link-btn {
	border: none;
	background: none;
	padding: 0;
	font-size: 13px;
	color: #2563eb;
	cursor: pointer;
	transition: opacity 0.2s;

	&:hover {
		opacity: 0.75;
		text-decoration: underline;
	}
}

.row-actions {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 4px;
}

.action-chip {
	border: 1px solid rgba(255, 71, 20, 0.25);
	background: rgba(255, 71, 20, 0.06);
	color: #ff4714;
	padding: 2px 6px;
	font-size: 13px;
	line-height: 1.3;
	border-radius: 999px;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: #ff4714;
		color: #fff;
		box-shadow: 0 2px 8px rgba(255, 71, 20, 0.28);
	}
}

.pager-card {
	flex-shrink: 0;
	padding: 6px 12px 8px;
	display: flex;
	justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/pddGoods.vue